angular
  .module('surfsightApp.controllers')
  .controller('userSettingsController', [
    '$scope',
    '$rootScope',
    '$log',
    '$state',
    '$timeout',
    '$interval',
    '$location',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    '$mdMedia',
    '$mdSidenav',
    '$mdToast',
    '$mdColors',
    'edgeFactory',
    'leafletData',
    function (
      $scope,
      $rootScope,
      $log,
      $state,
      $timeout,
      $interval,
      $location,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      $mdMedia,
      $mdSidenav,
      $mdToast,
      $mdColors,
      edgeFactory,
      leafletData
    ) {
      var $translate = $filter('translate')
      if ($localStorage.timeFormat) {
        $scope.timeFormat = $localStorage.timeFormat
      } else {
        $scope.timeFormat = 2
      }
      if ($localStorage.measurementUnits) {
        $scope.measurementUnits = $localStorage.measurementUnits
      } else {
        $scope.measurementUnits = 1
      }
      $scope.showUserSettings = function () {
        const userSettings = {
          ...$localStorage.userDetails.userSettings,
          mesaurement: $scope.measurementUnits,
          timeFormat: $scope.timeFormat
        }
        $http({
          method: 'PUT',
          url: `${USER_BASEURL}/user/settings`,
          data: userSettings
        })
          .then(response => {
            if (response.data.status.code === 0) {
              if ($scope.measurementUnits) {
                $localStorage.measurementUnits = $scope.measurementUnits
              }
              if ($scope.timeFormat) {
                $localStorage.timeFormat = $scope.timeFormat
              }
              $mdDialog.hide()
            }
          })
          .catch(error => {
            $mdDialog.cancel()
            $scope.showMessageToast(error.data.status.error)
          })
      }
      $scope.cancel = function () {
        $mdDialog.cancel()
      }
      $scope.showMessageToast = function (message) {
        var toast = $mdToast
          .simple()
          .textContent(message)
          .action($translate('ok'))
          .position('top right')
          .hideDelay(5000)
          .actionKey('F1')
        $mdToast
          .show(toast)
          .then(function (response) {
            if (response == 'ok') {
              //
            }
          })
          .catch(() => {})
      }
    }
  ])
